/**
 * Sidebar Configuration
 * @description Centralized sidebar configuration using the new MenuItem-based approach
 * Import icon components from the icons directory
 */

import React from 'react';
import { MenuItem, SidebarConfig } from '../components/layout/Sidebar';
import { 
  PatternAnalyzerIcon,
  MonitorsIcon,
  IncidentCorrelationIcon,
  SalesAnalyzerIcon
} from '../components/icons';
import { env } from './environment';

/**
 * Default Menu Items
 * @description Menu items for the main navigation sidebar
 * Note: Dashboard, Log Browser, and Page Scraper are hidden from the sidebar but routes remain accessible
 */
export const defaultMenuItems: MenuItem[] = [
  // Hidden items (routes still accessible via direct URL)
  // {
  //   id: 'dashboard',
  //   label: 'Dashboard',
  //   icon: <DashboardIcon />,
  //   path: '/',
  // },
  // {
  //   id: 'log-browser',
  //   label: 'Log Browser',
  //   icon: <LogBrowserIcon />,
  //   path: '/log-browser',
  // },
  // {
  //   id: 'page-scrapper',
  //   label: 'Page Scraper',
  //   icon: <SpiderWebIcon />,
  //   path: '/page-scrapper',
  // },
  {
    id: 'monitors',
    label: 'Monitors',
    icon: <MonitorsIcon />,
    path: '/monitors',
  },
  {
    id: 'log-analyzer',
    label: 'Log Analyzer',
    icon: <PatternAnalyzerIcon />,
    path: '/log-analyzer',
  },
  // {
  //   id: 'sales-analyzer',
  //   label: 'Sales Analyzer',
  //   icon: <SalesAnalyzerIcon />,
  //   path: '/sales-analyzer',
  // },
  {
    id: 'triage',
    label: 'Triage',
    icon: <IncidentCorrelationIcon />,
    path: '/triage',
  },
];

/**
 * Default Sidebar Configuration
 * @description This is the default configuration used by the application
 * Can be overridden by passing a config prop to the Sidebar component
 */
export const defaultSidebarConfig: SidebarConfig = {
  // Logo removed - now displayed in navbar only
  width: 100,
  backgroundColor: "#1a1a1a",
  textColor: "rgba(255, 255, 255, 0.8)",
  activeColor: "linear-gradient(270deg, #D33324 0%, #FB6F2A 100%)",
  hoverColor: "rgba(255, 255, 255, 0.1)",
  topOffset: 0,
  zIndex: 1000,
};

/**
 * Load Sidebar Configuration
 * @description Function to load sidebar configuration from server or use default
 * This can be extended to fetch from an API endpoint
 * @returns Promise<{menuItems: MenuItem[], config: SidebarConfig}>
 */
export async function loadSidebarConfig(): Promise<{
  menuItems: MenuItem[];
  config: SidebarConfig;
}> {
  try {
    // TODO: Implement API call to fetch configuration from server
    // const response = await fetch('/api/sidebar-config');
    // const serverConfig = await response.json();
    // return serverConfig;
    
    return {
      menuItems: defaultMenuItems,
      config: defaultSidebarConfig,
    };
  } catch (error) {
    console.error('Failed to load sidebar config from server, using default', error);
    return {
      menuItems: defaultMenuItems,
      config: defaultSidebarConfig,
    };
  }
}

